import { Check } from 'lucide-react';
import { cn } from '../../lib/cn';

export interface StepIndicatorProps {
  labels: readonly string[];
  /** Zero-based index of the step being shown. */
  current: number;
}

/**
 * The wizard's progress rail. Only the current step is emphasised and completed steps carry a quiet check —
 * colour stays on the one thing the user needs to locate (plan §2.2).
 */
export const StepIndicator = ({ labels, current }: StepIndicatorProps) => (
  <ol className="flex flex-wrap items-center gap-x-2 gap-y-3">
    {labels.map((label, index) => {
      const isDone = index < current;
      const isCurrent = index === current;

      return (
        <li
          key={label}
          className="flex items-center gap-2"
        >
          <span
            aria-current={isCurrent ? 'step' : undefined}
            className={cn(
              'inline-flex size-6 shrink-0 items-center justify-center rounded-full border text-xs font-medium',
              isCurrent ? 'border-primary bg-primary text-primary-foreground' : 'border-border text-muted-foreground',
            )}
          >
            {isDone ? <Check className="size-3.5" /> : index + 1}
          </span>
          <span className={cn('text-sm', isCurrent ? 'font-medium text-foreground' : 'text-muted-foreground')}>{label}</span>
          {index < labels.length - 1 ? <span className="mx-1 h-px w-6 bg-border" /> : null}
        </li>
      );
    })}
  </ol>
);
